import z from 'zod';
import { ImageTs } from '../../common';


//co-founder-card
export type CoFounderCard = z.output<typeof CoFounderCardSchema>;
export const CoFounderCardSchema = z.object({
  content: z.string(),
  picture: ImageTs,
});

//commitment-item
export type CommitmentItem = z.output<typeof CommitmentItemSchema>;
export const CommitmentItemSchema = z.object({
  title: z.string(),
  content: z.string(),
});

//ressource-card
export type RessourceCard = z.output<typeof RessourceCardSchema>;
export const RessourceCardSchema = z.object({
  title: z.string(),
  content: z.string(),
});
//ressource-section
export type RessourceSection = z.output<typeof RessourceSectionSchema>;
export const RessourceSectionSchema = z.object({
  title: z.string(),
  ressourceCards: RessourceCardSchema.array()
});

//commitment-card
export type CommitmentCard = z.output<typeof CommitmentCardSchema>;
export const CommitmentCardSchema = z.object({
  title: z.string(),
  commitmentItems: CommitmentItemSchema.array(),
  ressourcesSection: RessourceSectionSchema,
});

//join-us-card
export type JoinUsCard = z.output<typeof JoinUsCardSchema>;
export const JoinUsCardSchema = z.object({
  title: z.string(),
  content: z.string(),
  cta: z.string(),
  jobLink: z.string()
});

//mission-card
export type MissionCard = z.output<typeof MissionCardSchema>;
export const MissionCardSchema = z.object({
  title: z.string(),
  traveler: z.string(),
  retailer: z.string(),
});



//what-drive-us-slide
export type WhatDriveUsSlide = z.output<typeof WhatDriveUsSlideSchema>;
export const WhatDriveUsSlideSchema = z.object({
  title: z.string(),
  content: z.string(),
});
//what-drive-us
export type WhatDriveUs = z.output<typeof WhatDriveUsSchema>;
export const WhatDriveUsSchema = z.object({
  title: z.string(),
  slides: WhatDriveUsSlideSchema.array()
});

